
'use strict';

angular.module('Directives').directive('bbaInputChips', function($timeout) {
    return {
        'restrict': 'A',
        'require': 'ngModel',
        'scope': {
            ngModel: '=',
            selectOptions: '=ngItems'
        },
        'link': function linkingFunction($scope, element, attr) {
            $timeout(function(){
                element.bbaInputChips();
            });
            $scope.$watch('ngModel', function(o, n) {
                $timeout(function() {
                    element.bbaInputChips();
                });
            });
        },
        'controller': function($scope) {
        }
    }
});

// (function(){
//     'use strict';
//     angular.module('Directives').directive('bbaInputChips', bbaInputChips);
//     function bbaInputChips() {
//         return {
//             restrict: 'A',
//             require: 'ngModel',
//             replace: true,
//             scope: {
//                 ngModel: '=?'
//             },
//             link: bbaInputChipsLink
//         }

//         function bbaInputChipsLink($scope) {
//             $scope.inputValue = '';

//             $scope.removeItem = removeItem;
//             $scope.keydown = keydown;

//             function removeItem(index) {
//                 $scope.ngModel.splice(index, 1);
//             }

//             function keydown(event) {
//                 $scope.isInvalid = false;
//                 if (event.keyCode !== 13) { return; }

//                 if (!$scope.inputValue || isDuplicateEmail()) {
//                     $scope.isInvalid = true;
//                     return;
//                 }

//                 if ($scope.ngModel.length > 0) {
//                     $scope.ngModel.push($scope.inputValue);
//                     $scope.inputValue = '';
//                     return;
//                 }

//                 $scope.ngModel = [$scope.inputValue];
//                 $scope.inputValue = '';
//             }

//             function isDuplicateEmail() {
//                 const isFound = $scope.ngModel.find(d => d === $scope.inputValue);
//                 return !!isFound;
//             }
//         }
//     }
// })();



// WEBPACK FOOTER //
// ./js/directives/bbaInputChips.js